import { ApiIQuestion } from "../../domain/election";
import { QuestionValidationResult } from "../types";
import { BasicTextInputValue } from "./basic-text-typedef";

export const basicTextValidate = (ballot: ApiIQuestion, vote: BasicTextInputValue | undefined): QuestionValidationResult => {
    if (!vote || !vote.text_input || vote.text_input.length === 0) {
        return {
            valid: false,
            empty: true,
            reasons: [{ reason: 'Text input required' }]
        };
    }
    return {
        valid: true,
        empty: false
    };
};
